import { clsx } from 'clsx';
import type { BlendSource } from '@/lib/hooks/use-blended-kpis';

interface BlendSourceBadgeProps {
  source: BlendSource;
  sourceLabel: string;
  tenantWeight: number;
}

const SOURCE_STYLES: Record<BlendSource, { dot: string; bg: string; text: string }> = {
  industry_benchmark: { dot: 'bg-primary', bg: 'bg-primary-soft', text: 'text-primary-bright' },
  blended: { dot: 'bg-warn', bg: 'bg-warn-soft', text: 'text-warn' },
  your_data: { dot: 'bg-success', bg: 'bg-success-soft', text: 'text-success' },
  // Muted on purpose: "no data yet" is a neutral fact, not a warning.
  unavailable: { dot: 'bg-ink-dim', bg: 'bg-surface-2', text: 'text-ink-dim' },
};

export function BlendSourceBadge({ source, sourceLabel, tenantWeight }: BlendSourceBadgeProps) {
  const s = SOURCE_STYLES[source];
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-medium',
        s.bg, s.text,
      )}
      title={`${Math.round(tenantWeight * 100)}% personalized`}
    >
      <span className={clsx('h-1.5 w-1.5 shrink-0 rounded-full', s.dot)} />
      {sourceLabel}
    </span>
  );
}
